<template>
	<div
			v-if="body.id"
			class="taskItem"
			:class="{'disabled': !this.permissions[9]}"
			:id="body.orderId"
			:style="`width: ${body.w}px; background: ${body.color}`"
			ref="element"
			@mousedown.self="onMouseDown"
			@mouseup.self="onMouseUp"
			@mousemove.self="onMouseMove"
			@dblclick.self="onEditWorkOrder(body.order_id, !!body.isLightOrder)"
	>
		<div @mousedown.self="onResizeStart" @mousemove.self="onResizeMove($event, 1)" @mouseup.self="onResizeEnd" class="arrow left"></div>
		<span>{{ body.name }}</span>
		<div class="status">
			<span class="statusColor" :style="`background: ${body['status_color']}`"></span>
			<span class="statusText">{{ body.status }}</span>
		</div>
		<div @mousedown.self="onResizeStart" @mousemove.self="onResizeMove" @mouseup.self="onResizeEnd" class="arrow right"></div>
		<div class="toolTipWo">
			<p :key="value" v-for="value in body.info">{{ value }}</p>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { shiftX } from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerItem/constants";

export default {
	name: "PlanerItem",
	props: {
		body: Object
	},
	data: () => ({
		dragObject: {},
		treeStructure: {},
		elemResize: {}
	}),
	computed: {
		...mapGetters([ 'getTabPermission' ]),
		permissions() {
			return this.getTabPermission[69];
		}
	},
	methods: {
		...mapActions([ 'onTimeLineTotal' ]),
		onResizeStart(evt) {
			if (!this.permissions[9]) return false;

			if (evt.which !== 1) return false;
			const elem = evt.target;

			if (!elem) return;
			this.elemResize.avatar = this.createAvatar(1);
			this.elemResize.elem = elem;
			this.elemResize.line = document.querySelector('.lineTime');
			this.elemResize.scrollX = document.querySelector('.planerTable').getBoundingClientRect().x;
			this.elemResize.parent = elem.closest('.taskItem');
			this.elemResize.elem.classList.add('resize');

			this.elemResize.downX = evt.pageX;
			this.elemResize.width = this.elemResize.parent.clientWidth;
		},
		onResizeMove(evt, isLeft) {
			if (!this.elemResize.elem) return;

			const { scrollX } = this.elemResize;
			const moveX = evt.pageX - this.elemResize.downX;
			const { left, x, y } = this.elemResize.elem.getBoundingClientRect();
			const targetElem = this.findResizeElem({ clientX: x, clientY: y });

			if (targetElem) {
				const attrs = this.getAttrElem(targetElem);
				if (isLeft) attrs.isLeft = isLeft;
				this.onTimeLineTotal(attrs);
				this.elemResize.line.style.display = 'block';
				this.elemResize.line.style.left = ((left - scrollX) - (isLeft ? 2 : -4)) + 'px';

				let width = null;
				if (isLeft) {
					width = this.elemResize.width - moveX;
				} else {
					width = this.elemResize.width + moveX;
				}

				if (width % 15 === 0) {
					if (isLeft) {
						this.elemResize.parent.style.left = moveX + 'px';
					}

					this.elemResize.parent.style.width = width + 'px';
				}

				this.$emit('updateStartDrop');
			}
		},
		onResizeEnd(evt) {
			if (this.elemResize.elem) {
				this.finishResize(evt);
			}

			this.elemResize?.elem?.classList?.remove('resize');
			this.elemResize.line.style.display = 'none';
			this.elemResize = {};
			this.$emit('updateLines');
		},
		onResizeFinish() {
			const parent = this.elemResize.elem.closest('.taskItem');
			const { left: clientX, top: clientY } = parent.getBoundingClientRect();
			const width = parent.getBoundingClientRect().width;
			const targetElem = this.findResizeElem({ clientX, clientY });
			const attrs = this.getAttrElem(targetElem);

			this.$emit('updateStructureWidth', { to: { width, ...attrs } });
		},
		finishResize(evt) {
			const dropElem = this.findResizeElem(evt);

			if (dropElem) {
				this.onResizeFinish();
			} else {
				this.onResizeCancel();
			}
		},
		findResizeElem( { clientX, clientY } ) {
			const { elem } = this.elemResize;
			elem.closest('.taskItem').style.pointerEvents = 'none';
			const targetElem = document.elementFromPoint(clientX, clientY);
			elem.closest('.taskItem').style.pointerEvents = 'auto';

			if (targetElem === null || targetElem.classList.contains('taskItem')) return null;
			if (targetElem.nodeName === 'TD') return targetElem.firstChild;
			return targetElem;
		},
		onMouseDown(evt) {
			if (!this.permissions[9]) return false;
			if (evt.which !== 1) return false;

			const elem = evt.target;

			if (!elem) return;
			this.dragObject.elem = elem;

			this.dragObject.downX = evt.pageX;
			this.dragObject.downY = evt.pageY;
		},
		onRemoveClassTargetElem() {
			const table = document.querySelector('.planerTable');
			if (table) {
				const list = table.querySelectorAll('tr');
				list.forEach((item) => {
					item.classList.remove('targetTr');
				});
			}
		},
		setClassTargetElem(pageX, pageY) {
			const targetElem = document.elementFromPoint(pageX, pageY);
			if (targetElem) {
				this.onRemoveClassTargetElem();
				const tr = targetElem.closest('tr');
				if (tr) tr.classList.add('targetTr');
			}
		},
		onMouseMove(evt) {
			if (!this.dragObject.elem) return;

			if (!this.dragObject.avatar) {
				const moveX = evt.pageX - this.dragObject.downX;
				const moveY = evt.pageY - this.dragObject.downY;

				if ( Math.abs(moveX) < 3 && Math.abs(moveY) < 3 ) return false;

				this.dragObject.avatar = this.createAvatar();
				if (!this.dragObject.avatar) {
					this.dragObject = {};
				}

				const coords = this.getCoords(this.dragObject.avatar);
				this.dragObject.shiftX = shiftX;
				this.dragObject.shiftY = this.dragObject.downY - coords.top;
				this.dragObject.width = coords.width;

				this.startDrag(evt);
			}

			this.dragObject.avatar.style.left = evt.pageX - this.dragObject.shiftX + 'px';
			this.dragObject.avatar.style.top = evt.pageY - this.dragObject.shiftY + 'px';
			this.setClassTargetElem(evt.pageX + this.dragObject.width, evt.pageY);

			return false;
		},
		onEditWorkOrder(orderId, isLightOrder) {
			this.$emit('updateEditWorkOrder', { orderId, isLightOrder });
		},
		getCoords(elem) {
			const box = elem.getBoundingClientRect();
			return {
				top: box.top + pageYOffset,
				left: box.left + pageXOffset,
				width: box.width
			};
		},
		createAvatar(isResize) {
			let avatar = null;
			if (isResize) {
				avatar = this.elemResize;
				const old = {
					width: avatar.width || ''
				};

				avatar.rollback = function() {
					avatar.style.width = old.width;
				};
			} else {
				avatar = this.dragObject.elem;
				const old = {
					parent: avatar.parentNode,
					nextSibling: avatar.nextSibling,
					position: avatar.position || '',
					left: avatar.left || '',
					top: avatar.top || '',
					zIndex: avatar.zIndex || ''
				};

				avatar.rollback = function() {
					old.parent.insertBefore(avatar, old.nextSibling);
					avatar.style.position = old.position;
					avatar.style.left = old.left;
					avatar.style.top = old.top;
					avatar.style.zIndex = old.zIndex;
				};
			}

			return avatar;
		},
		startDrag() {
			const { avatar } = this.dragObject;

			document.body.appendChild(avatar);
			avatar.style.zIndex = 9999;
			avatar.style.cursor = 'grabbing';
			avatar.classList.add('draggable');
			this.$emit('updateStartDrop');
		},
		onMouseUp(evt) {
			if (this.dragObject.avatar) {
				this.finishDrag(evt);
			}

			this.dragObject = {};
			this.onRemoveClassTargetElem();
		},
		finishDrag(e) {
			const dropElem = this.findDroppable(e);
			if (dropElem) {
				this.onDragEnd(this.dragObject, dropElem);
			} else {
				this.onDragCancel();
			}

			this.$emit('updateLines');
		},
		findDroppable(event) {
			this.dragObject.elem.style.pointerEvents = 'none';
			const elem = document.elementFromPoint(event.clientX, event.clientY);
			// const elemLast = document.elementFromPoint((event.clientX + (this.dragObject.width - shiftX + 5)), event.clientY);
			const list = [];
			for (let i = 15; i < this.dragObject.width; i++) {
				if (i % 5 === 0) {
					list.push(document.elementFromPoint((event.clientX + (i - shiftX + 5)), event.clientY));
				}
			}

			this.dragObject.elem.style.pointerEvents = 'auto';
			if ((elem === null || elem.classList.contains('taskItem')) ||
					(list.some(item => item !== null && item?.classList?.contains('taskItem')))) return null;
			return elem.closest('.droppable');
		},
		getAttrElem(elem) {
			const keyTask = elem.getAttribute('keyTask');
			const keyItem = elem.getAttribute('keyItem');
			const keyBody = +elem.getAttribute('keyBody');
			const position = +elem.getAttribute('position');

			return { keyTask, keyItem, keyBody, position };
		},
		onDragEnd({ elem }, parent) {
			elem.style.left = 'inherit';
			elem.style.top = 'inherit';
			elem.style.cursor = 'pointer';
			elem.classList.remove('draggable');

			const attrs = this.getAttrElem(parent);

			this.$emit('updateStructure', { to: attrs });
		},
		onDragCancel() {
			this.dragObject.avatar.rollback();
		},
		onResizeCancel() {
			this.elemResize.parent.style.width = this.elemResize.avatar.width + 'px';
			this.elemResize.parent.style.left = '0px';
		}
	}
};
</script>

<style lang="scss" scoped>
@import "PlanerItem";
</style>

<style lang="scss">
@import "PlanerItemAll";
</style>

